var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-footer',{staticStyle:{"z-index":"6"},attrs:{"app":"","color":"#3C7DC7","height":"35"}},[_c('span',{staticStyle:{"color":"white"}},[_vm._v(" © "+_vm._s(_vm.year)+" | "+_vm._s(_vm.product)+" "+_vm._s(_vm.version)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }